import { Form } from "react-bootstrap";
import React, { FormEvent, useState } from "react";
import { User } from "firebase/auth";
import { Callback } from "../../common/models/utils";
import { useTranslation } from "../../common/models/Dictionary";
import { texts } from "./texts";
import { capitalize, upperCase } from "lodash";
import InputField from "../Atoms/Input/InputField";
import { Buttons } from "../Atoms/Button/Button";
import { User as AuthUser } from "@firebase/auth";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import { showToast } from "App";
import { ToastType } from "Contexts/Notification";

const LoginForm = ({
  callback,
  login,
  onOtpSent,
}: {
  callback: Callback<User>;
  login: (
    e: FormEvent<HTMLFormElement>,
    callback: Callback<AuthUser>
  ) => Promise<void>;
  onOtpSent: (email: string) => void;
}) => {
  const translate = useTranslation();

  const strings = {
    email: capitalize(translate(texts.email)),
    login: upperCase(translate(texts.login)),
    password: capitalize(translate(texts.password)),
  };

  const [showPassword, setShowPassword] = useState(false);

  // const toggleShowPassword = () => {
  //   setShowPassword(!showPassword);
  // };

  const sendOtpForEmailAuth = httpsCallable(functions,"sendOtpForEmailAuth");

  const [email, setEmail] = useState('');
  const [isSendingOtp, setIsSendingOtp] = useState(false);

  const handleSendOTP = async () => {
    if (!email) {
      alert('Please enter your email first!');
      return;
    }

    setIsSendingOtp(true);

    try {
      const getOtp = await sendOtpForEmailAuth({email});
      if (onOtpSent) onOtpSent(email);
    } catch (error: any) {      
        showToast(error.message || "Failed to send OTP", ToastType.ERROR);              
    } finally {
      setIsSendingOtp(false);
    }
  };


  return (
    <Form
      onSubmit={async (e) => {
        // e.preventDefault();
        // await login(e, callback);
      }}
    >
       <Form.Group className="mb-3 w-100" controlId="login-email">
        <InputField
          style={{ color: 'var(--blue-violet)', boxShadow: window.screen.width > 979 ? '0px 3px 6px #00000029' : '' }}
          fullWidth={true}
          type="email"
          placeholder={strings.email}
          name="email"
          required
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSendingOtp}
        />
      </Form.Group>

      <Buttons.Primary
        type="button"
        onClick={handleSendOTP}
        disabled={!email || isSendingOtp}
        fullWidth
      >
        {isSendingOtp ? 'Sending OTP...' : 'Continue'}
      </Buttons.Primary>
    </Form>
  );
};

export default LoginForm;
